import React from 'react';
import { buildLessonDocument, documentYear } from './lessonDocument';
import { lessonSubtitle } from './library/lessonLibraryModel';

const Block = ({ block }) => {
  if (block.type === 'theme') {
    return <p className="lesson-doc-theme text-slate-900"><span className="font-bold">Thema</span> — <span className="italic">{block.text}</span></p>;
  }
  if (block.type === 'subheading') {
    return <h4 className="lesson-doc-sub pt-1 text-xs font-semibold uppercase tracking-wide text-slate-500">{block.text}</h4>;
  }
  if (block.type === 'list') {
    const List = block.ordered ? 'ol' : 'ul';
    return (
      <List className={`lesson-doc-list space-y-1 pl-6 text-slate-700 ${block.ordered ? 'list-decimal' : 'list-disc'}`}>
        {block.items.map((item, index) => <li key={index}>{item}</li>)}
      </List>
    );
  }
  if (block.type === 'scripture') {
    return (
      <div className="lesson-doc-scripture space-y-0.5 border-l-4 border-slate-300 bg-slate-50 py-1.5 pl-3 pr-2">
        <p className="font-bold text-slate-900">{block.reference}</p>
        {block.text && <p className="whitespace-pre-line text-slate-700">{block.text}</p>}
      </div>
    );
  }
  if (block.type === 'question') {
    return <p className="lesson-doc-question whitespace-pre-line pl-6 -indent-6 text-slate-700"><span className="mr-1 font-medium">{block.number}.</span>{block.text}</p>;
  }
  return <p className="whitespace-pre-line text-slate-700">{block.text}</p>;
};

// Dezelfde zeven programmaonderdelen als in de afdruk (lessonDocument.js), altijd genummerd 1 t/m 7. Gebruikt door de bibliotheek en de publieke deelpagina.
const LessonDocumentView = ({ lesson, organization = null, showHeader = false }) => {
  const doc = buildLessonDocument(lesson);
  const subtitle = lessonSubtitle(lesson);
  return (
    <article className="lesson-doc space-y-5 text-[15px] leading-6" data-testid="lesson-document">
      {showHeader && (
        <header className="flex items-center justify-between gap-3 border-b-2 border-slate-900 pb-3">
          <p className="text-lg font-bold tracking-wide text-slate-900">CONNECTBIJEENKOMST</p>
          {organization?.logo_url && <img src={organization.logo_url} alt={organization.name || ''} className="max-h-12 max-w-[7.5rem] object-contain" />}
        </header>
      )}
      <div>
        <h2 className="text-xl font-bold text-slate-900">{doc.title}</h2>
        {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
      </div>
      {doc.sections.map((section) => (
        <section key={section.key} className="lesson-doc-section space-y-2">
          <h3 className="font-bold text-slate-900"><span className="mr-1">{section.number}.</span>{section.label}</h3>
          {section.blocks.map((block, index) => <Block key={`${section.key}-${index}`} block={block} />)}
        </section>
      ))}
      {doc.agenda.length > 0 && (
        <section className="lesson-doc-section space-y-2">
          <h3 className="font-bold text-slate-900">Gemeenteagenda</h3>
          {doc.agenda.map((block, index) => <Block key={`agenda-${index}`} block={block} />)}
        </section>
      )}
      {showHeader && (
        <footer className="border-t border-slate-300 pt-2 text-xs text-slate-500">
          {[`CONNECTLES ${documentYear(lesson.lesson_date)}`, organization?.name].filter(Boolean).join(' – ')}
        </footer>
      )}
    </article>
  );
};

export default LessonDocumentView;
